<template>
  <Legenda titulo="Compra em pallet">
    <div class="text-truncate">
      <template v-if="Number(props.lastro_palete) > 0">
        {{ formatarValorExibido(qt_camandas_computed) }} cam.
        |
        <template v-if="Number(props.altura_palete) > 0">
          {{ formatarValorExibido(qt_pallet_computed) }} pallet
        </template>
        <template v-else>-</template>
      </template>
      <template v-else>-</template>
    </div>

    <template #legenda>
      <template v-if="Number(props.lastro_palete) > 0 && Number(props.altura_palete) > 0">
        Você está comprando {{ formatarValorExibido(qt_camandas_computed) }} camadas.
        Um pallet comporta {{ formatarValorExibido(props.altura_palete) }} camadas.
        Em uma camada cabem {{ formatarValorExibido(props.lastro_palete) }} unidades em {{ props.unidade_compra }}.
      </template>

      <template v-else-if="Number(props.lastro_palete) > 0">
        Você está comprando {{ formatarValorExibido(qt_camandas_computed) }} camadas.
        Não foi possível informar camadas por pallet. Cadastre: Empilhamento máximo (altura do palete).
        Em uma camada cabem {{ formatarValorExibido(props.lastro_palete) }} unidades em {{ props.unidade_compra }}.
      </template>

      <template v-else>
        Não foi possível calcular Compra em pallet. Cadastre:
        {{ Number(props.lastro_palete) > 0 ? '' : 'lastro' }}
        {{ !Number(props.lastro_palete) && !Number(props.altura_palete) ? ' e ' : '' }}
        {{ Number(props.altura_palete) > 0 ? '' : 'altura' }}
      </template>
    </template>
  </Legenda>
</template>

<script setup>
import {computed} from "vue";
import {formatarValor, formatarValorComCasas} from "@/helpers";
import Legenda from "@/components/produto/detalhes/Legenda.vue";

const props = defineProps({
  lastro_palete: {
    type: Number,
    required: true,
  },
  altura_palete: {
    type: Number,
    required: true,
  },
  quantidade_compra: {
    type: Number,
    required: true,
  },
  unidade_compra: String,
});

const quantidade_compra_computed = computed(() => Math.max(props.quantidade_compra, 0));

const qt_camandas_computed = computed(() => {
  if (!props.lastro_palete) {
    return 0;
  }

  return (quantidade_compra_computed.value / props.lastro_palete) || 0;
});

const qt_pallet_computed = computed(() => {
  if (!props.lastro_palete || !props.altura_palete) {
    return 0;
  }

  return (quantidade_compra_computed.value / (props.lastro_palete * props.altura_palete)) || 0;
});

function formatarValorExibido(valor) {
  if (!valor) {
    return 0;
  }

  if (Number(valor) < 1) {
    return formatarValorComCasas(valor, 4);
  }

  return formatarValor(valor);
}
</script>

<style scoped>
p {
  margin: 0;
}
</style>
